import React from "react";
import { Drawer } from "antd";
import "./style.css";

export default function AppDrawer({
  title,
  visible,
  handleDrawer,
  width,
  placement,
  closable,
  body,
}) {
  return (
    <Drawer
      className="pi-drawer-panel"
      wrapClassName="pi-drawer-wrap"
      width={width || "min(100vw, 360px)"}
      title={title}
      placement={placement || "right"}
      closable={closable || false}
      onClose={handleDrawer}
      maskClosable
      visible={visible}
      destroyOnClose
      getContainer={() => document.body}
      contentWrapperStyle={{
        top: "var(--pi-header-h, 88px)",
        height: "calc(100% - var(--pi-header-h, 88px))",
        maxHeight: "calc(100dvh - var(--pi-header-h, 88px))",
      }}
    >
      {body}
    </Drawer>
  );
}
